import { addFinraGridColumnId, finraGridNumericValueFormatter, finraGridPercentValueFormatter, finraGridMonthYearFormatter, finraGridNumericValueFormatterNoRound } from "src/app/shared/utils/utils";

// TODO: Assumptions are made on how the response is formatted. Do not deploy this to PROD until G32LI data is returned from rc-services API!
export interface G32LateInitiationDataInterface {
    period: string;
}

export interface SubmissionTotals extends G32LateInitiationDataInterface {
    totalFormsCount: number;
    lateFormsCount: number;
    lateFormsPercentage: number;
    UpdateFormCount: number;
    UpdateFormPercent: number;
    latenessRank: number;

    firmTotalFormCount: number
    industryTotalFormCount: number;
    industryLateFormCount: number;
    industryLateFormPercent: number;
    industryUpdateFormCount: number;
    industryUpdateFormPercent: number;
}

export interface LatenessMagnitude extends G32LateInitiationDataInterface {
    total1DayLateness: number;
    total2DaysLateness: number;
    total3to5DaysLateness: number;
    total6to15DaysLateness: number;
    total16to30DaysLateness: number;
    totalAbove30DaysLateness: number;
    firmAverageLateness: number;
    firmMedianLateness: number;

    industryAverageLateness: number;
    industryMedianLateness: number;
}

export interface G32LateInitiationResponseData {
    submissionTotals: SubmissionTotals[];
    latenessMagnitudes: LatenessMagnitude[];
}

export const ALL_SUBMISSION_TOTALS_COLUMN_DEFS = addFinraGridColumnId([
    {
        headerName: 'Period',
        valueGetter: params =>
            (<SubmissionTotals>params.data).period,
        valueFormatter: finraGridMonthYearFormatter
    },
    {
        headerName: 'Firm',
        headerClass: 'lines',
        cellClass: 'lines',
        children: [
            {
                headerName: 'Total Forms Count',
                headerClass: 'lines',
                cellClass: 'lines',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).totalFormsCount,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: 'Late Forms Count',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).lateFormsCount,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: 'Late Forms Percentage',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).lateFormsPercentage,
                valueFormatter: finraGridPercentValueFormatter
            },
            {
                headerName: 'UTP Forms Count',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).UpdateFormCount,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: 'UTP Forms Percentage',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).UpdateFormPercent,
                valueFormatter: finraGridPercentValueFormatter
            },
            {
                headerName: 'Late Rank',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).latenessRank,
                valueFormatter: finraGridNumericValueFormatter
            }
        ]
    },
    {
        headerName: 'Industry',
        headerClass: 'lines',
        cellClass: 'lines',
        children: [
            {
                headerName: 'Firm Count',
                headerClass: 'lines',
                cellClass: 'lines',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).firmTotalFormCount,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: 'Total Forms Count',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).industryTotalFormCount,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: 'Late Forms Count',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).industryLateFormCount,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: 'Late Forms Percentage',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).industryLateFormPercent,
                valueFormatter: finraGridPercentValueFormatter
            },
            {
                headerName: 'UTP Forms Count',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).industryUpdateFormCount,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: 'UTP Forms Percentage',
                valueGetter: params =>
                    (<SubmissionTotals>params.data).industryUpdateFormPercent,
                valueFormatter: finraGridPercentValueFormatter
            }
        ]
    }
]);

export const ALL_LATENESS_MAGNITUDE_COLUMN_DEFS = addFinraGridColumnId([
    {
        headerName: 'Period',
        valueGetter: params =>
            (<LatenessMagnitude>params.data).period,
        valueFormatter: finraGridMonthYearFormatter
    },
    {
        headerName: 'Firm',
        headerClass: 'lines',
        cellClass: 'lines',
        children: [
            {
                headerName: '1 Day',
                headerClass: 'lines',
                cellClass: 'lines',
                valueGetter: params =>
                    (<LatenessMagnitude>params.data).total1DayLateness,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: '2 Days',
                valueGetter: params =>
                    (<LatenessMagnitude>params.data).total2DaysLateness,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: '3-5 Days',
                valueGetter: params =>
                    (<LatenessMagnitude>params.data).total3to5DaysLateness,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: '6-15 Days',
                valueGetter: params =>
                    (<LatenessMagnitude>params.data).total6to15DaysLateness,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: '16-30 Days',
                valueGetter: params =>
                    (<LatenessMagnitude>params.data).total16to30DaysLateness,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: '>30 Days',
                valueGetter: params =>
                    (<LatenessMagnitude>params.data).totalAbove30DaysLateness,
                valueFormatter: finraGridNumericValueFormatter
            },
            {
                headerName: 'Average Lateness',
                valueGetter: params =>
                    (<LatenessMagnitude>params.data).firmAverageLateness,
                valueFormatter: finraGridNumericValueFormatterNoRound
            },
            {
                headerName: 'Median Lateness',
                valueGetter: params =>
                    (<LatenessMagnitude>params.data).firmMedianLateness,
                valueFormatter: finraGridNumericValueFormatterNoRound
            }
        ]
    },
    {
        headerName: 'Industry',
        headerClass: 'lines',
        cellClass: 'lines',
        children: [
            {
                headerName: 'Industry Average Lateness',
                headerClass: 'lines',
                cellClass: 'lines',
                valueGetter: params =>
                    (<LatenessMagnitude>params.data).industryAverageLateness,
                valueFormatter: finraGridNumericValueFormatterNoRound
            },
            {
                headerName: 'Industry Median Lateness',
                valueGetter: params =>
                    (<LatenessMagnitude>params.data).industryMedianLateness,
                valueFormatter: finraGridNumericValueFormatterNoRound
            }
        ]
    }
]);

export const G_32_LATE_INITIATION_COLUMN_DEFS = {
    submissionTotals: ALL_SUBMISSION_TOTALS_COLUMN_DEFS,
    latenessMagnitudes: ALL_LATENESS_MAGNITUDE_COLUMN_DEFS
}